import api from "./api";
import { API_ENDPOINTS } from "../utils/constants";

export const newsService = {
  getAllNews: async (params = {}) => {
    try {
      const response = await api.get(API_ENDPOINTS.NEWS, { params });
      return response;
    } catch (error) {
      throw error;
    }
  },
  createNews: async (newsData) => {

    try {
      const response = await api.post(API_ENDPOINTS.NEWS, newsData);
      return response;
    } catch (error) {
      throw error;
    }
  },
  getNewsById: async (id) => {
    try {
      const response = await api.get(`${API_ENDPOINTS.NEWS}/${id}`);
      return response;
    } catch (error) {
      throw error;
    }
  },
  getCategories: async () => {
    try {
      const response = await api.get(API_ENDPOINTS.NEWS_CATEGORIES);
      return response;
    } catch (error) {
      throw error;
    }
  },
  updateNews: async (id, newsData) => {
    try {
      const response = await api.put(`${API_ENDPOINTS.NEWS}/${id}`, newsData);
      return response;
    } catch (error) {
      throw error;
    }
  },
  isPublishNews: async (id, payload) => {
    try {
      const response = await api.put(`${API_ENDPOINTS.PUBLISH}/${id}`, payload);
      return response;
    } catch (error) {
      throw error;
    }
  },
  getScripts: async () => {
    try {
      const response = await api.get(`${API_ENDPOINTS.SCRIPT}`);
      return response;
    } catch (error) {
      throw error;
    }
  },
  getTagSectors: async () => {
    try {
      const response = await api.get(`${API_ENDPOINTS.TAG_SECTOR}`)
      return response;
    } catch (error) {
      throw (error)
    }
  },
  getTagIndustries: async () => {
    try {
      const response = await api.get(`${API_ENDPOINTS.TAG_INDUSTRY}`)
      return response;
    } catch (error) {
      throw (error)
    }
  },
  getInternalTokens: async () => {
    try {
      const response = await api.get('/internaltoken/list');
      return response;
    } catch (error) {
      throw error;
    }
  },
  getUniqueGroupsByType: async (type) => {
    try {
      const response = await api.post('/graphql', {
        query: `
          query GetUniqueGroupsByType($type: String!) {
            getUniqueGroupsByType(type: $type)
          }
        `,
        variables: { type }
      });
      return response.data.getUniqueGroupsByType;
    } catch (error) {
      throw error;
    }
  },
  getUniqueCredits: async () => {
    try {
      const response = await api.get(`${API_ENDPOINTS.NEWS}/credits`);
      return response;
    } catch (error) {
      throw error;
    }
  },
  getNewsImages: async () => {
    try {
      const response = await api.get(API_ENDPOINTS.NEWS_IMAGES);
      return response;
    } catch (error) {
      throw error;
    }
  },

  getAllNotificationTypes: async () => {
    try {
      const response = await api.get(API_ENDPOINTS.NOTIFICATION_TYPES);
      return response.data || [];
    } catch (error) {
      throw error;
    }
  },

  sendNotification: async (payload) => {
    try {
      const response = await api.post("/notification/send", payload);
      return response;
    } catch (error) {
      throw error;
    }
  },

};
